import React from 'react'
import Bar from './Bar'
import Dark from './Dark'
import Menu from './Menu'
import Avatar from './Avatar'
function Header() {
  return (
    <>
    <div className='w-full flex justify-center'>
        <div className='w-11/12 h-full py-4 flex justify-between'>
        <Dark/>
        <Menu/>
        <Bar/>
        </div>
    </div>
        <Avatar/>
        </>
  )
}

export default Header
